import { Component, OnInit } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { Filterable } from '@common/utilities/Filterable';
import { roleInfo, UserRecord } from '@core/services/data.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { UsersService } from '@core/services/users.service';
import { UserEditorComponent } from '@routes/editors/user-editor/user-editor.component';

@Component({
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  public users = new Filterable<UserRecord>({
    extractor: i => [i.Username].union(i.Roles),
    grouper: i => i.Roles.map(x => ({ name: 'Vai trò', option: roleInfo(x).name, description: roleInfo(x).description }))
  });

  public get loading(): boolean {
    return !this.sync.ready(UsersService) && this.users.empty;
  }

  public info = roleInfo;

  constructor(private us: UsersService, private modal: ModalService, private sync: SynchronizationService) { }

  ngOnInit(): void {
    this.sync.when(UsersService).commit(() => {
      this.users.source = this.us.all.filter(i => i.ID > 0).order(i => i.ID);
    })
  }

  edit(user: UserRecord) {
    this.modal.show(UserEditorComponent, { state: { user: user } }).content.change.subscribe(updated => {
      this.users.source = this.users.source.filter(i => i != user).union([updated]);
      this.us.synchronize();
    });
  }
}
